import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Calendar, Stethoscope } from 'lucide-react';
import { Button } from './ui/button';

const DoctorCard = ({ doctor }) => {
  const navigate = useNavigate();

  return (
    <div className="card-doctor" data-testid={`doctor-card-${doctor.id}`}>
      <div className="flex items-start gap-4">
        {/* Avatar */}
        <div className="w-20 h-20 rounded-xl bg-slate-100 overflow-hidden flex-shrink-0">
          <img
            src={doctor.image_url || 'https://via.placeholder.com/80'}
            alt={doctor.name}
            className="w-full h-full object-cover"
          />
        </div>

        {/* Info */}
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <h3 className="font-semibold text-slate-900 truncate">{doctor.name}</h3>
            {/* Availability Indicator */}
            <span className={doctor.is_available ? 'status-available' : 'status-unavailable'} />
          </div>

          <div className="flex items-center gap-1 text-[#2E7DCD] mt-1">
            <Stethoscope className="w-4 h-4" />
            <span className="text-sm font-medium">{doctor.specialty}</span>
          </div>

          {doctor.bio && (
            <p className="text-sm text-slate-500 mt-2 line-clamp-2">{doctor.bio}</p>
          )}

          <div className="flex items-center justify-between mt-3">
            <div>
              <div className="flex gap-3">
                <div>
                  <span className="text-xs text-slate-500">Online</span>
                  <p className="font-bold text-[#2563EB]">${doctor.consultation_fee_online?.toFixed(2) || '50.00'}</p>
                </div>
                <div>
                  <span className="text-xs text-slate-500">Presencial</span>
                  <p className="font-bold text-[#E52225]">${doctor.consultation_fee_presencial?.toFixed(2) || '75.00'}</p>
                </div>
              </div>
            </div>

            <Button
              onClick={() => navigate(`/citas?doctor=${doctor.id}`)}
              className="btn-secondary h-9 px-4"
              disabled={!doctor.is_available}
              data-testid={`book-appointment-${doctor.id}`}
            >
              <Calendar className="w-4 h-4 mr-1" />
              Agendar
            </Button>
          </div>
        </div>
      </div>

      {/* Status Message */}
      {!doctor.is_available && (
        <p className="text-xs text-amber-600 mt-3 bg-amber-50 px-3 py-2 rounded-lg">
          El doctor no está disponible en este momento
        </p>
      )}
    </div>
  );
};

export default DoctorCard;
